import React, { useContext, useEffect, useState } from "react";
import { useReactTable, getCoreRowModel, flexRender } from "@tanstack/react-table";

import {
    fetchSampoornaDataOnTime,
    fetchtataAlertTableDetailsOnTime,
    fetchonZippyTableDetail,
    fetchtataKavachTableDetailsOnTime,
    fetchtataZippyTableDetails,
    fetchtataonZippyTableDetails,
} from "./apiInsights";

import { FilterContext } from "../../context/Filter";
import Tataalerttable from "./Tataalerttable";
import Tatazippy from "./Tablezippy";
import Tataonalerttable from "./Tataontimealert";
import Tataonzippy from "./Tatazippytable";
import Tataonkavach from "./Tataonkavch";

const Ontimetable = () => {
    const { superArn: parArn, childArn } = useContext(FilterContext);

    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;

    const [data, setData] = useState([]);
    const [alertData, setAlertData] = useState([]);
    const [zippyData, setZippyData] = useState([]);
    const [kavachData, setKavachData] = useState([]);
    const [loading, setLoading] = useState(false);

    const getOntimeData = async () => {
        try {
            setLoading(true);
            const payload = { [key]: value };
            const res = await fetchSampoornaDataOnTime(payload);

            const formatted = [
                {
                    srNo: 1,
                    program: "Tata Alert",
                    "2019-20": res?.tataAlertOnTime?.list?.find(y => y.year === "2019-20")?.value || 0,
                    "2020-21": res?.tataAlertOnTime?.list?.find(y => y.year === "2020-21")?.value || 0,
                    "2021-22": res?.tataAlertOnTime?.list?.find(y => y.year === "2021-22")?.value || 0,
                    total: res?.tataAlertOnTime?.list?.find(y => y.year === "ALL")?.value || 0,
                    type: "alert",
                },
                {
                    srNo: 2,
                    program: "Tata Zippy",
                    "2019-20": res?.tataZippyOnTime?.results?.find(y => y.year === "2019-20")?.value || 0,
                    "2020-21": res?.tataZippyOnTime?.results?.find(y => y.year === "2020-21")?.value || 0,
                    "2021-22": res?.tataZippyOnTime?.results?.find(y => y.year === "2021-22")?.value || 0,
                    total: res?.tataZippyOnTime?.results?.find(y => y.year === "ALL")?.value || 0,
                    type: "zippy",
                },
                {
                    srNo: 3,
                    program: "Tata Kavach",
                    "2019-20": res?.tataKavachOnTime?.results?.find(y => y.year === "2019-20")?.value || 0,
                    "2020-21": res?.tataKavachOnTime?.results?.find(y => y.year === "2020-21")?.value || 0,
                    "2021-22": res?.tataKavachOnTime?.results?.find(y => y.year === "2021-22")?.value || 0,
                    total: res?.tataKavachOnTime?.results?.find(y => y.year === "ALL")?.value || 0,
                    type: "kavach",
                },
            ];

            setData(formatted);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };


    const handleTataAlert = async (year) => {
        const payload = { [key]: value, yearsData: year };
        const res = await fetchtataAlertTableDetailsOnTime(payload);
        setAlertData(res?.result || []);
        setZippyData([]);
        setKavachData([]);
    };

    const handleTataZippy = async (year) => {
        const payload = { [key]: value, yearsData: year };
        const res = await fetchtataonZippyTableDetails(payload);
        setZippyData(res?.data?.data || []);
        setAlertData([]);
        setKavachData([]);
    };

    const handleTataKavach = async (year) => {
        const payload = { [key]: value, yearsData: year };
        const res = await fetchtataKavachTableDetailsOnTime(payload);


        setKavachData(res?.data?.data || []); // <-- add this line
        setAlertData([]);
        setZippyData([]);
    };

    useEffect(() => {
        getOntimeData();
    }, []);


    const yearColumn = (keyName) => ({
        accessorKey: keyName,
        header: keyName,
        cell: ({ row }) => {
            const program = row.original.program;
            const value = row.getValue(keyName);
            const year = keyName;

            return (
                <span
                    className="cursor-pointer text-blue-600 hover:underline"
                    onClick={() => {
                        if (program === "Tata Alert") handleTataAlert(year);
                        if (program === "Tata Zippy") handleTataZippy(year);
                        if (program === "Tata Kavach") handleTataKavach(year);
                    }}
                >
                    {value}
                </span>
            );
        },
    });

    const columns = [
        { accessorKey: "srNo", header: "Sr No" },
        { accessorKey: "program", header: "Program" },
        yearColumn("2019-20"),
        yearColumn("2020-21"),
        yearColumn("2021-22"),
        { accessorKey: "total", header: "# Of Vehicles" },
    ];

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    // -------------------------------------------------------------
    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-4">Sampoorna On Time Data</h2>

            <div className="overflow-x-auto border rounded-lg">
                {loading ? (
                    <div className="p-6 text-center">Loading...</div>
                ) : (
                    <table className="min-w-full text-sm border-collapse">
                        <thead className="bg-gray-100">
                            {table.getHeaderGroups().map((hg) => (
                                <tr key={hg.id}>
                                    {hg.headers.map((header) => (
                                        <th
                                            key={header.id}
                                            className="border px-4 py-2 font-medium text-left"
                                        >
                                            {header.column.columnDef.header}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody>
                            {table.getRowModel().rows.map((row) => (
                                <tr key={row.id} className="even:bg-gray-50">
                                    {row.getVisibleCells().map((cell) => (
                                        <td key={cell.id} className="border px-4 py-2">
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {alertData.length > 0 && (
                <div className="mt-6">
                    <h3 className="text-lg font-semibold mb-2 text-[#267CB8]">Tata Alert Details</h3>
                    <Tataonalerttable data={alertData} />
                </div>
            )}

            {zippyData.length > 0 && (
                <div className="mt-6">
                    <h3 className="text-lg font-semibold mb-2 text-[#267CB8]">Tata Zippy Details</h3>
                    <Tataonzippy data={zippyData} />
                </div>
            )}

            {kavachData.length > 0 && (
                <div className="mt-6">
                    <h3 className="text-lg font-semibold mb-2 text-[#267CB8]">Tata Kavach Details</h3>
                    <Tataonkavach data={kavachData} />
                </div>
            )}
        </div>
    );
};

export default Ontimetable;
